import React from "react";
import { useForm } from "react-hook-form";
import { useParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { auth_actions } from "../../redux-store";
const ResetPassword = () => {
  const { handleSubmit, register, errors, getValues, reset } = useForm();
  const dispatch = useDispatch();
  const { token } = useParams();

  const changePasswordHandler = () => {
    const data = getValues();

    if (data) {
      dispatch(auth_actions.reset_password({ password: data.new_pass, token }));
      
    }
    reset();
  };
  return (
    <div>
      <section className="pwd-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <h2>Reset Your Password</h2>
              <form className="theme-form">
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control mb-0"
                    id="new_pass"
                    name="new_pass"
                    placeholder="New Password"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <label htmlFor="new_pass" className="error">
                    {errors.new_pass && errors.new_pass.message}
                  </label>
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control mb-0"
                    id="conf_password"
                    name="conf_password"
                    placeholder="Confirm Password"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                      validate: (v) =>
                        getValues().new_pass === v || "Passwords don't match",
                    })}
                  />
                  <label htmlFor="conf_password" className="error">
                    {errors.conf_password && errors.conf_password.message}
                  </label>
                </div>

                <Link
                  href={process.env.PUBLIC_URL}
                  className="btn btn-solid"
                  onClick={handleSubmit(changePasswordHandler)}
                >
                  Submit
                </Link>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
